var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"like-button",class:{ active: _vm.active },attrs:{"type":"button"}},_vm.$listeners),[_c('MaterialIcon',{staticClass:"mr-1",attrs:{"icon":"thumb_up"}}),_c('span',[_vm._t("default",[_vm._v(" いいね ")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }